export default (() => {

    function isRegex (regexString) {
        if (regexString === undefined) {            
            return wealthify.error.throwError('regex.isRegex', 'regexString must be defined');
        }

        try {
            new RegExp(regexString);
        } catch (error) {
            return false;
        }

        return true;
    }

    function toInputFriendlyString (regexString) {
        if (!regexString) {            
            return regexString;
        }

        const captureStringWithinSlashesRegex = /^\/(.+)\/$/;

        return regexString.toString().replace(captureStringWithinSlashesRegex, '$1');
    }

    function toRegex(regexString){

        if (regexString === undefined) {            
            return wealthify.error.throwError('regex.toRegex', 'regexString must be defined');
        }

        if (typeof regexString !== 'string' || typeof regexString !== 'object') {
            return wealthify.error.throwError('regex.toRegex', 'regexString must be of type string or regex');
        }

        try {
            return new RegExp(regexString);
        } catch (error) {
            return wealthify.error.throwError(this.tagName, `Unable to create RegExp from value ${regexString}`);
        }
    }

    return {
        isRegex,
        toInputFriendlyString,
        toRegex
    };

})();